import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-modal-fp-bulk-upload-wrapper',
  templateUrl: './modal-fp-bulk-upload-wrapper.component.html',
  styleUrls: ['./modal-fp-bulk-upload-wrapper.component.scss'],
})
export class ModalFpBulkUploadWrapperComponent {
  @Output() closeEmitter = new EventEmitter<boolean>();
}
